import {ID} from '#/components/PolicyUpdateOverlay/updates/202508/config'

/**
 * The singulary active update ID. This is configured here to ensure that
 * the relationship is clear.
 */
export const ACTIVE_UPDATE_ID = ID
